import '../../App.css';
import React, { useContext, useEffect, useState } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';

function ModalEditarLocalidade({ currentPage }) {
    const { EditarLocalidade, EdicaoLocalidade, setEdicaoLocalidade, setModalEditarLocalidade, Organizacoes, ListaOrganizacao, setError } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)
    const [organizacaoKey, setOrganizacaoKey] = useState(EdicaoLocalidade?.organizacao.key)

    const editar = (e) => {
        if (e) e.preventDefault();
        if (!EdicaoLocalidade.nome) {
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }

        EditarLocalidade(organizacaoKey, currentPage)
            .then(() => {
                setModalEditarLocalidade(false)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const handleChange = (event) => {
        setEdicaoLocalidade({ ...EdicaoLocalidade, [event.target.name]: event.target.value })
    }

    useEffect(() => {
        ListaOrganizacao()
    }, [])

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Editar localidade</h1>
                    <div className="btn-close-modal" onClick={() => setModalEditarLocalidade(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div>
                    <div className="modal-content">
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control maxLength={255} defaultValue={EdicaoLocalidade.nome} onChange={handleChange} name="nome" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Organização</Form.Label>
                                    <Form.Select aria-label="Default select example" onChange={(e) => setOrganizacaoKey(e.target.value)} name="organizacaoKey">
                                        <option value="0">Selecione</option>
                                        {Organizacoes && Organizacoes.sort((a, b) => a?.nome?.localeCompare(b?.nome))?.map((item) => {
                                            return (
                                                <option key={item.id} value={item.key} selected={item.key == EdicaoLocalidade?.organizacao.key ? true : false}>
                                                    {item.nome.length > 120 ? item.nome.substring(0, 120) + '...' : item.nome}
                                                </option>
                                            )
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Descrição</Form.Label>
                                    <Form.Control maxLength={255} defaultValue={EdicaoLocalidade.descricao} onChange={handleChange} name="descricao" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditarLocalidade(false)}>Cancelar</button>
                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                            <button type='button' className="btn-dash btn-criar" style={btnCriar} onClick={(e) => {
                                e.preventDefault();
                                editar();
                            }}>Salvar</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalEditarLocalidade